"use client";
import {
  useSelectList
} from "../__chunks/PDRDZB4I.js";
import "../__chunks/DMSZFK7W.js";
import {
  useSelectProviderContext
} from "../__chunks/TKSBJDO3.js";
import "../__chunks/FTNKYK65.js";
import "../__chunks/3IEDWLST.js";
import "../__chunks/3D6OCOHF.js";
import "../__chunks/MADQZZRL.js";
import {
  usePopover
} from "../__chunks/BYD75WXE.js";
import {
  createDialogComponent
} from "../__chunks/KXSO5EFT.js";
import "../__chunks/3N4FFVWW.js";
import "../__chunks/NOYDL3YS.js";
import "../__chunks/BULCTPRV.js";
import "../__chunks/6BJGLK2C.js";
import "../__chunks/CS347UVZ.js";
import "../__chunks/IUB2BTEK.js";
import "../__chunks/XHJGS6Z5.js";
import "../__chunks/TL67WVI6.js";
import "../__chunks/MKDDWKFK.js";
import "../__chunks/72E5EPFF.js";
import "../__chunks/OOBDFMJL.js";
import "../__chunks/X6WIMZJE.js";
import "../__chunks/677M2CI3.js";
import "../__chunks/6GXEOXGT.js";
import "../__chunks/WCIYB4YS.js";
import "../__chunks/UYRJLDVS.js";
import "../__chunks/CK3UW3AQ.js";
import "../__chunks/WKWX2XLD.js";
import "../__chunks/7452U3HH.js";
import "../__chunks/XPF5GU3Q.js";
import "../__chunks/CBTO7DFZ.js";
import "../__chunks/RQZGFHI2.js";
import "../__chunks/TE637IA7.js";
import "../__chunks/XXVAHUAO.js";
import "../__chunks/J55AVALY.js";
import "../__chunks/WAZE6NXP.js";
import "../__chunks/SHA3WOPI.js";
import "../__chunks/IFT5JEUU.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/5M6RSQEC.js";
import "../__chunks/I62TROYO.js";
import "../__chunks/HZJ2XALY.js";
import "../__chunks/EKQEJRUF.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/select/select-popover.ts
var TagName = "div";
var useSelectPopover = createHook(
  function useSelectPopover2(_a) {
    var _b = _a, { store, alwaysVisible } = _b, props = __objRest(_b, ["store", "alwaysVisible"]);
    const context = useSelectProviderContext();
    store = store || context;
    props = useSelectList(__spreadValues({ store, alwaysVisible }, props));
    props = usePopover(__spreadValues({ store, alwaysVisible }, props));
    return props;
  }
);
var SelectPopover = createDialogComponent(
  forwardRef(function SelectPopover2(props) {
    const htmlProps = useSelectPopover(props);
    return createElement(TagName, htmlProps);
  }),
  useSelectProviderContext
);
export {
  SelectPopover,
  useSelectPopover
};
